<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        block
        v-on="on"
      >
        Create Holiday Detail
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Holiday"
      text="Create Holiday Detail"
      class="mb-0"
    > 
      <form
        v-if="dialog"
        ref="detailCreateForm"
      >
        <v-container class="pb-0">
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="selectedHoliday"
                v-validate="'required'"
                :error-messages="errors.collect('holiday')"
                data-vv-name="holiday" 
                :items="holidays"
                item-text="name"
                return-object
                label="Holiday"
                outlined
                @change="handleHolidaySelected"
              >
                <template v-slot:prepend-inner>
                  <v-icon>
                    mdi-calendar
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-menu
                id="date"
                v-model="datemenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="selectedDateDisplay"
                    v-validate="'required'"
                    label="Holiday Date"
                    :error-messages="errors.collect('date')" 
                    data-vv-name="date"
                    readonly
                    outlined
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  :min="earliestDate"
                  :max="latestDate"
                  class="datepicker"
                  no-title
                  @input="datemenu = false"
                />
              </v-menu>              
            </v-col>
          </v-row>          
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <span class="font-weight-bold bold">  State & Departments:</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div
                class="selection"
                data-simplebar
              >
                <v-treeview
                  v-model="selectedStateDepartments"
                  :items="stateDepartments"
                  selectable
                  dense
                  open-all
                  return-object
                />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-btn @click="selectDeselect">
          Select/Deselect All
        </v-btn>

        <v-spacer />
        <v-btn
          :disabled="progressing"
          class="px-10"
          text
          @click="resetForm();dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="px-5 white--text"       
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      states: {
        type: Array,
        default: () => {
          return []
        },
      }, 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        holidays: [],
        selectedHoliday: null,
        selectedStates: [],
        selectedStateDepartments: [],
        stateDepartments: [],
        form: {
          date: this.$moment().format('YYYY-MM-DD'),
        },
        datemenu: false,
      }
    },
    computed: {
      selectedDateDisplay () {
        return this.$moment(this.form.date, 'YYYY-MM-DD').format('D MMM YYYY') 
      },
      earliestDate () {
        return this.$moment().year() + '-01-01'
      },
      latestDate () {
        return this.$moment().year() + 1 + '-12-31'
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$resetData()
        } else {
          this.loadData()
        }
      },
    },
    methods: { 
      handleHolidaySelected (holiday) {
        this.setDefaultStateSelection(holiday)
      },
      setDefaultStateSelection (holiday) {
        if (holiday.is_national === 1) {
          this.selectedStates = this.states
        } else {
          this.selectedStates = []
        }
      },

      prepareFormData () {
        return {
          ...this.form,
          state_departments: this.prepareStateDepartmentsFormData(),
        }
      },

      getDepartmentIds (value) {
        let ids = []
   
        value.map(item => {
          ids.push(item.id.substring(0, item.id.indexOf('-')))
        })
        return ids
      },

      prepareStateDepartmentsFormData () {
        let finalData = []
        _.chain(this.selectedStateDepartments)
          .groupBy('state_id')
          .map((value, key) => {
            finalData.push({
              states: key,
              departments: this.getDepartmentIds(value),
            })
          })
          .value()
        return finalData
      },

      loadData () {
        this.$http.all([
          this.$api.hrisHolidays().list(),
          this.$api.hrisDepartments().list(),
        ])
          .then(this.$http.spread((holidays, departments) => {
            this.holidays = holidays.data
            this.stateDepartments = this.states

            this.stateDepartments.map(item => {
              item.children = this.formatDepartments(item.id, JSON.parse(JSON.stringify(departments.data)))
            })
          }))
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)

            this.$api.hrisHolidayDetails().create(this.selectedHoliday.id, this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.setDialog(false)
                  this.$emit('created')
                  this.$snack({ message: 'Added new holiday detail' })
                }
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Error create holiday detail', 
                })
              })
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      formatDepartments (id, departments) {
        departments.map(department => {
          department.id = department.id + '-' + id
          department.state_id = id
        })
 
        return departments
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        if (!status) {
          this.resetForm()
        }
        this.dialog = status
      },
      resetForm () {
        this.selectedStates = []
        if (this.$refs.detailCreateForm) {
          this.$refs.detailCreateForm.reset()
        }
        this.$validator.reset()
      },

      selectDeselect () {
        if (this.selectedStateDepartments.length > 0) {
          this.selectedStateDepartments = []
        } else { 
          let allSelections = []
        
          this.stateDepartments.map(item => {
            item.children.map(item2 => {
              allSelections.push(item2)
            })
          })

          this.selectedStateDepartments = allSelections
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }

  .bold{
    font-size:20px
  }

  .selection{
    height: 400px;
    overflow-y: scroll
    }

 ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
  }

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  padding-right:5px;
  background:white
}
</style>
